import { kebabize } from './kebabize';

export const tokenToVariable = <T extends string = string>(token: T, omitVar = false) => {
    const v = `--${kebabize(token)}`;
    if (omitVar)
        return v;
    return `var(${v})`;
};
